
import ConsultaReclamacionesModel from "@/models/ConsultaReclamaciones/ConsultaReclamacionesModel";
import UserComplaintQuery from "@/models/ConsultaReclamaciones/UserComplaintQuery";
import UmbracoApiService from "@/services/UmbracoApiService";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import WsdlService from "@/services/WsdlService";

@Component({})
export default class ConsultaReclamacionesForm extends Vue {
	@Prop() isProcessing: boolean;
    public userComplaintQuery: UserComplaintQuery = new UserComplaintQuery();
	public todaysDate: Date = new Date();
	public initialDate: Date = new Date();

    public mounted() {
        this.userComplaintQuery.userId = this.$store.state.user.cedula;
		this.setInitialFromDate();
    }
	public setInitialFromDate(){
		const currentDate = new Date();
		this.initialDate.setFullYear(currentDate.getFullYear() - 5);
	}
    public process() {
        this.$emit("process", this.userComplaintQuery);
    }
    public setFromDate(date: string) {
		let partitionedDateString = date.split('-');
        this.userComplaintQuery.fromDate = `${partitionedDateString[1]}/${partitionedDateString[2]}/${partitionedDateString[0]}`;
    }
    public setToDate(date: string) {
		let partitionedDateString = date.split('-');
        this.userComplaintQuery.toDate = `${partitionedDateString[1]}/${partitionedDateString[2]}/${partitionedDateString[0]}`;
    }
	returnHome(){
		window.location.href = GlobalConfig.PORTAL_BASE_URL
	}
}
